import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
});

// Intercepteur pour ajouter le token à chaque requête
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur pour gérer les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (email, password) => api.post('/auth/login', { email, password });
export const register = (userData) => api.post('/auth/register', userData);

// Employees
export const getEmployees = () => api.get('/employees');
export const getEmployee = (id) => api.get(`/employees/${id}`);
export const updateEmployee = (id, data) => api.put(`/employees/${id}`, data);

// Productivity
export const getProductivity = (params) => api.get('/productivity', { params });
export const addProductivity = (data) => api.post('/productivity', data);
export const deleteProductivity = (id) => api.delete(`/productivity/${id}`);

// HR - Absences
export const getAbsences = (params) => api.get('/hr/absences', { params });
export const addAbsence = (data) => api.post('/hr/absences', data);
export const updateAbsence = (id, data) => api.put(`/hr/absences/${id}`, data);
export const deleteAbsence = (id) => api.delete(`/hr/absences/${id}`);

// HR - Delays
export const getDelays = (params) => api.get('/hr/delays', { params });
export const addDelay = (data) => api.post('/hr/delays', data);
export const deleteDelay = (id) => api.delete(`/hr/delays/${id}`);

// HR - Bonuses
export const getBonuses = (params) => api.get('/hr/bonuses', { params });
export const addBonus = (data) => api.post('/hr/bonuses', data);
export const deleteBonus = (id) => api.delete(`/hr/bonuses/${id}`);

// Metrics
export const getDashboard = (params) => api.get('/metrics/dashboard', { params });
export const getEmployeeMetrics = (id, params) => api.get(`/metrics/employee/${id}`, { params });

// Clients
export const getClients = () => api.get('/clients');
export const getClient = (id) => api.get(`/clients/${id}`);
export const createClient = (data) => api.post('/clients', data);
export const updateClient = (id, data) => api.put(`/clients/${id}`, data);
export const deleteClient = (id) => api.delete(`/clients/${id}`);

// Event Codes
export const getEventCodes = (clientId) => api.get(`/clients/${clientId}/event-codes`);
export const createEventCode = (clientId, data) => api.post(`/clients/${clientId}/event-codes`, data);
export const updateEventCode = (clientId, id, data) => api.put(`/clients/${clientId}/event-codes/${id}`, data);
export const deleteEventCode = (clientId, id) => api.delete(`/clients/${clientId}/event-codes/${id}`);

// Drivers
export const registerDriver = (data) => api.post('/drivers/register', data);
export const getDrivers = () => api.get('/drivers');
export const getDriverProfile = () => api.get('/drivers/me');
export const getDriver = (id) => api.get(`/drivers/${id}`);
export const updateDriver = (id, data) => api.put(`/drivers/${id}`, data);
export const updateDriverClients = (id, client_ids) => api.post(`/drivers/${id}/clients`, { client_ids });

// Daily Entries
export const getDailyEntries = (params) => api.get('/daily-entries', { params });
export const getDailyEntry = (id) => api.get(`/daily-entries/${id}`);
export const createDailyEntry = (data) => api.post('/daily-entries', data);
export const deleteDailyEntry = (id) => api.delete(`/daily-entries/${id}`);
export const getDailySummary = (params) => api.get('/daily-entries/summary/stats', { params });

export default api;
